module.exports = __webpack_public_path__ + "img/icon83.923db253.png";